export type Movie = {
  id: string;
  title: string;
  year: number;
  region: "日本" | "韩国";
  genres: string[];
  cover: string;
  summary: string;
  synopsis: string;
  director: string;
  cast: string[];
  duration: number;
  releaseDate: string;
  rating: number;
  views: number;
  updatedAt: string;
  featured: boolean;
};

export const movies: Movie[] = [
  {
    id: "yinghua-canying",
    title: "樱花残影",
    year: 2023,
    region: "日本",
    genres: ["剧情", "爱情"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20moody%20drama%20film%20poster%2C%20a%20young%20woman%20in%20a%20flowing%20silk%20dress%20gazing%20through%20a%20rain%20streaked%20window%20at%20dusk%2C%20deep%20burgundy%20and%20warm%20amber%20lighting%2C%20soft%20shadows%2C%20elegant%20melancholy%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20editorial%20cinematic%20aesthetic%2C%20no%20text&width=600&height=900&seq=movie-cover-01&orientation=portrait",
    summary: "一场迟到了二十年的重逢，将两个家庭的秘密重新翻出水面。",
    synopsis:
      "摄影师美咲在整理母亲遗物时，发现一叠从未寄出的信件，收信人指向一个陌生的名字。她循着线索回到京都，遇见了如今经营着一家旧书店的拓真。随着两人逐渐熟悉，一段横跨二十年的往事缓缓展开——关于错过、隐忍与被时光掩埋的承诺。美咲必须在真相与体面之间做出抉择，而拓真也终于要面对自己一直逃避的过去。",
    director: "佐藤悠介",
    cast: ["水野莉子", "高桥亮介", "中村麻衣"],
    duration: 118,
    releaseDate: "2023-04-12",
    rating: 8.4,
    views: 128000,
    updatedAt: "2023-12-20",
    featured: true,
  },
  {
    id: "hanjiang-wangshi",
    title: "汉江往事",
    year: 2022,
    region: "韩国",
    genres: ["剧情", "悬疑"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20noir%20drama%20film%20poster%2C%20a%20lone%20figure%20walking%20along%20a%20foggy%20riverside%20promenade%20at%20night%2C%20city%20lights%20reflected%20on%20dark%20water%2C%20deep%20wine%20red%20and%20cool%20gray%20tones%2C%20atmospheric%20tension%2C%20cinematic%20wide%20composition%2C%20moody%20realism%2C%20no%20text&width=600&height=900&seq=movie-cover-02&orientation=portrait",
    summary: "一名记者追查旧案，却发现自己家族的往事正是谜团的中心。",
    synopsis:
      "记者振宇接手一桩尘封多年的失踪旧案，原本只想写一篇报道，却在走访中一次次撞见自己熟悉的名字。随着调查深入，他发现案件与父亲当年的抉择密不可分。真相越清晰，代价也越沉重。振宇不得不在职业良知与血脉亲情之间，寻找一个足以说服自己的答案。",
    director: "金秀贤",
    cast: ["朴振宇", "李诗恩", "崔民浩"],
    duration: 124,
    releaseDate: "2022-09-08",
    rating: 8.1,
    views: 96000,
    updatedAt: "2023-11-30",
    featured: false,
  },
  {
    id: "dongjing-yeyu",
    title: "东京夜雨",
    year: 2021,
    region: "日本",
    genres: ["爱情", "剧情"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20romantic%20drama%20film%20poster%2C%20two%20figures%20standing%20under%20a%20translucent%20umbrella%20on%20a%20wet%20tokyo%20street%20at%20night%2C%20glowing%20signage%20bokeh%2C%20warm%20amber%20and%20burgundy%20palette%2C%20tender%20melancholy%20mood%2C%20shallow%20depth%20of%20field%2C%20elegant%20cinematic%20composition%2C%20no%20text&width=600&height=900&seq=movie-cover-03&orientation=portrait",
    summary: "两个错过彼此的人，在一场雨夜重新学会告别。",
    synopsis:
      "藤井在东京经营着一家深夜营业的咖啡馆。某个雨夜，多年未见的前恋人美咲推门而入。两人聊起各自这些年的生活，也终于谈起当年那段没有说出口的遗憾。雨水一直下到天亮，他们也终于学会了如何体面地放下。",
    director: "山田隆",
    cast: ["石原莉奈", "木村翔", "藤井美咲"],
    duration: 110,
    releaseDate: "2021-06-18",
    rating: 7.9,
    views: 88000,
    updatedAt: "2023-10-15",
    featured: true,
  },
  {
    id: "shouer-milou",
    title: "首尔迷楼",
    year: 2020,
    region: "韩国",
    genres: ["剧情", "惊悚"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20suspense%20drama%20film%20poster%2C%20interior%20of%20an%20old%20seoul%20apartment%20building%20stairwell%20bathed%20in%20dim%20amber%20light%2C%20long%20shadows%2C%20mysterious%20lonely%20atmosphere%2C%20deep%20wine%20red%20accents%2C%20moody%20architectural%20photography%2C%20narrative%20tension%2C%20no%20text&width=600&height=900&seq=movie-cover-04&orientation=portrait",
    summary: "搬进老公寓的女人，发现邻居们都在隐瞒同一件事。",
    synopsis:
      "智媛独自搬进市中心一栋即将拆迁的老公寓，想借此安静地整理自己的生活。然而邻里之间反常的沉默、深夜里反复响起的脚步声，让她逐渐察觉到这栋楼藏着不为人知的过往。当好奇心变成不得不面对的危险，智媛才明白，有些秘密是整栋楼一起守着。",
    director: "郑在勋",
    cast: ["韩智媛", "吴承宪", "权娜拉"],
    duration: 116,
    releaseDate: "2020-10-22",
    rating: 7.7,
    views: 79000,
    updatedAt: "2023-09-28",
    featured: false,
  },
  {
    id: "jingdu-muse",
    title: "京都暮色",
    year: 2019,
    region: "日本",
    genres: ["剧情", "文艺"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20literary%20drama%20film%20poster%2C%20a%20woman%20in%20a%20kimono%20standing%20in%20a%20quiet%20kyoto%20alley%20at%20sunset%2C%20wooden%20machiya%20houses%2C%20warm%20golden%20and%20muted%20burgundy%20tones%2C%20serene%20nostalgic%20atmosphere%2C%20soft%20film%20grain%2C%20elegant%20cinematic%20composition%2C%20no%20text&width=600&height=900&seq=movie-cover-05&orientation=portrait",
    summary: "一位陶艺世家的女儿，在传统与自我之间悄然转身。",
    synopsis:
      "千夏是京都一家老陶艺工坊的独女，从小被期许继承家业。然而当她遇见一位来自都市的策展人，内心沉寂已久的渴望被重新点燃。在家族荣誉与个人选择之间，她用一个夏天的时间，慢慢找回了属于自己的模样。",
    director: "小林和也",
    cast: ["藤原千夏", "森下彻", "冈田由纪"],
    duration: 108,
    releaseDate: "2019-05-30",
    rating: 7.6,
    views: 64000,
    updatedAt: "2023-08-11",
    featured: false,
  },
  {
    id: "fushan-miwu",
    title: "釜山迷雾",
    year: 2023,
    region: "韩国",
    genres: ["剧情", "悬疑"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20mystery%20drama%20film%20poster%2C%20a%20coastal%20city%20harbor%20shrouded%20in%20thick%20morning%20mist%2C%20silhouetted%20cranes%20and%20fishing%20boats%2C%20deep%20burgundy%20sky%20with%20cool%20gray%20fog%2C%20atmospheric%20film%20noir%20mood%2C%20moody%20cinematic%20wide%20shot%2C%20no%20text&width=600&height=900&seq=movie-cover-06&orientation=portrait",
    summary: "港口城市的一桩意外，牵出三个家庭难以言说的牵连。",
    synopsis:
      "釜山港的一起意外事故，让素不相识的三个人被卷进同一场调查。海雾散去之后，每个人都不得不面对自己曾经的选择。这是一个关于责任、愧疚与在迷雾中寻找出路的故事，冷峻而克制。",
    director: "李俊昊",
    cast: ["金泰妍", "郑雨盛宪", "李到贤"],
    duration: 121,
    releaseDate: "2023-02-16",
    rating: 8.0,
    views: 87000,
    updatedAt: "2023-12-02",
    featured: true,
  },
  {
    id: "naikang-zhiyue",
    title: "奈良之约",
    year: 2022,
    region: "日本",
    genres: ["爱情", "剧情"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20gentle%20romance%20film%20poster%2C%20two%20people%20cycling%20through%20a%20nara%20park%20with%20deer%20at%20golden%20hour%2C%20warm%20amber%20sunlight%20through%20autumn%20trees%2C%20soft%20burgundy%20highlights%2C%20tender%20nostalgic%20mood%2C%20shallow%20depth%20of%20field%2C%20elegant%20cinematic%20look%2C%20no%20text&width=600&height=900&seq=movie-cover-07&orientation=portrait",
    summary: "每年同一天的约定，藏着一段谁都不愿先开口的心事。",
    synopsis:
      "章太和结衣从高中起约定，每年秋天都要一起去奈良看鹿。多年以后，两人各自有了不同的生活，却依旧守着这个小小的约定。当其中一方终于要离开这座城市，他们才决定在最后一次同行中，把藏了多年的话说清楚。",
    director: "中村健",
    cast: ["山本结衣", "佐佐木章太", "田中裕子"],
    duration: 104,
    releaseDate: "2022-10-05",
    rating: 7.8,
    views: 71000,
    updatedAt: "2023-07-19",
    featured: false,
  },
  {
    id: "renchen-jiuimeng",
    title: "仁川旧梦",
    year: 2021,
    region: "韩国",
    genres: ["剧情", "家庭"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20family%20drama%20film%20poster%2C%20an%20elderly%20woman%20looking%20out%20over%20a%20busy%20incheon%20harbor%20from%20an%20apartment%20window%2C%20dusty%20warm%20afternoon%20light%2C%20muted%20burgundy%20and%20beige%20tones%2C%20quiet%20reflective%20mood%2C%20soft%20natural%20lighting%2C%20cinematic%20composition%2C%20no%20text&width=600&height=900&seq=movie-cover-08&orientation=portrait",
    summary: "一位母亲回到旧居，重新面对被自己搁置半生的家庭。",
    synopsis:
      "年迈的顺子回到仁川的老公寓，打算处理掉已故丈夫留下的房子。街坊的闲谈、旧物中的照片，让她不得不重新回顾自己作为妻子与母亲的一生。在与儿女的相处中，那些年积攒的误解与沉默，终于有了被听见的机会。",
    director: "朴成宇",
    cast: ["尹静姬", "金康民", "李秀妍"],
    duration: 112,
    releaseDate: "2021-03-11",
    rating: 7.9,
    views: 68000,
    updatedAt: "2023-06-24",
    featured: false,
  },
  {
    id: "beihai-dao-zhi-dong",
    title: "北海道之冬",
    year: 2020,
    region: "日本",
    genres: ["剧情", "文艺"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20winter%20drama%20film%20poster%2C%20a%20lone%20woman%20walking%20through%20a%20snowy%20hokkaido%20village%20at%20blue%20hour%2C%20warm%20lamp%20glow%20from%20windows%2C%20deep%20burgundy%20scarf%20against%20white%20snow%2C%20serene%20melancholy%20atmosphere%2C%20soft%20cinematic%20lighting%2C%20elegant%20composition%2C%20no%20text&width=600&height=900&seq=movie-cover-09&orientation=portrait",
    summary: "放逐自己到雪国的女人，在一间旅馆里遇见了重新出发的勇气。",
    synopsis:
      "在都市里受挫的菜绪，独自来到北海道的偏远小镇，在一间老旅馆做起临时工。漫长的雪季里，她与寡言的老板、形形色色的旅人相处，渐渐放下心结。当春天到来，她也终于准备好回到自己的人生中去。",
    director: "高桥修",
    cast: ["宫崎菜绪", "渡边诚", "井上真央希"],
    duration: 106,
    releaseDate: "2020-12-18",
    rating: 7.5,
    views: 57000,
    updatedAt: "2023-05-14",
    featured: false,
  },
  {
    id: "jizhou-dao-de-xiatian",
    title: "济州岛的夏天",
    year: 2019,
    region: "韩国",
    genres: ["爱情", "剧情"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20summer%20romance%20film%20poster%2C%20a%20couple%20standing%20on%20a%20jeju%20island%20cliff%20overlooking%20a%20turquoise%20sea%20at%20golden%20sunset%2C%20windswept%20hair%2C%20warm%20amber%20and%20burgundy%20undertones%2C%20bittersweet%20nostalgic%20mood%2C%20cinematic%20wide%20composition%2C%20no%20text&width=600&height=900&seq=movie-cover-10&orientation=portrait",
    summary: "一个只属于夏天的相遇，却在往后很多年里持续发酵。",
    synopsis:
      "大学毕业前的最后一个夏天，敏浩和秀雅在济州岛做起了民宿义工。短短两个月的相处，让他们都看见了彼此身上久违的自由。夏天结束后，两人回到各自的城市，那段时光却成了之后许多年里最温柔的回望。",
    director: "金敏哲",
    cast: ["郑秀雅", "姜敏浩", "朴慧珍"],
    duration: 115,
    releaseDate: "2019-07-26",
    rating: 7.7,
    views: 62000,
    updatedAt: "2023-04-30",
    featured: true,
  },
  {
    id: "hengbin-lianren",
    title: "横滨恋人",
    year: 2018,
    region: "日本",
    genres: ["爱情", "剧情"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20romantic%20film%20poster%2C%20a%20couple%20on%20a%20ferris%20wheel%20at%20yokohama%20waterfront%20at%20night%2C%20colorful%20city%20lights%20reflected%20on%20the%20bay%2C%20warm%20golden%20and%20deep%20burgundy%20palette%2C%20tender%20urban%20romance%20mood%2C%20bokeh%20lights%2C%20cinematic%20composition%2C%20no%20text&width=600&height=900&seq=movie-cover-11&orientation=portrait",
    summary: "两个在横滨打拼的年轻人，用一年的时间学会相爱与体谅。",
    synopsis:
      "来自小城的玲奈与拓海，在横滨的同一家公司相遇。他们一边为生活奔波，一边笨拙地学着如何去爱一个人。房租、加班、梦想与现实的差距，让这段感情经历了一次次考验，也让他们慢慢懂得了陪伴的分量。",
    director: "井上隆一",
    cast: ["新垣玲奈", "松本拓海", "石田沙耶"],
    duration: 102,
    releaseDate: "2018-08-17",
    rating: 7.4,
    views: 54000,
    updatedAt: "2023-03-12",
    featured: false,
  },
  {
    id: "daegu-de-mimi",
    title: "大邱的秘密",
    year: 2018,
    region: "韩国",
    genres: ["剧情", "悬疑"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20suspense%20film%20poster%2C%20a%20suburban%20daegu%20house%20at%20dusk%20with%20one%20lit%20window%2C%20long%20shadows%20across%20an%20empty%20street%2C%20deep%20wine%20red%20and%20gray%20tones%2C%20quiet%20ominous%20atmosphere%2C%20moody%20cinematic%20lighting%2C%20no%20text&width=600&height=900&seq=movie-cover-12&orientation=portrait",
    summary: "一个普通家庭的平静，被一封匿名信彻底打破。",
    synopsis:
      "大邱的一户普通人家收到匿名信后，原本安稳的生活开始出现裂痕。母亲、父亲与即将高考的女儿，各自都藏着不愿被揭开的心事。随着信任一点点瓦解，他们必须决定：是继续维持体面的假象，还是直面彼此的裂痕。",
    director: "崔东勋",
    cast: ["河正元", "宋智恩", "柳承雅"],
    duration: 119,
    releaseDate: "2018-11-15",
    rating: 7.6,
    views: 51000,
    updatedAt: "2023-02-08",
    featured: false,
  },
  {
    id: "shenhu-wangshi",
    title: "神户往事",
    year: 2017,
    region: "日本",
    genres: ["剧情", "文艺"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20period%20drama%20film%20poster%2C%20an%20old%20port%20town%20street%20in%20kobe%20with%20western%20style%20buildings%20at%20sunset%2C%20warm%20amber%20light%20and%20burgundy%20shadows%2C%20nostalgic%20melancholy%20atmosphere%2C%20soft%20film%20grain%2C%20elegant%20cinematic%20composition%2C%20no%20text&width=600&height=900&seq=movie-cover-13&orientation=portrait",
    summary: "一座港城的旧影里，藏着一代人的离散与重逢。",
    synopsis:
      "神户的老街上，年迈的咖啡馆主人收到了一位老友的来信。信件把他带回半个世纪前的港口岁月，那是一个关于离别、承诺与重逢的故事。他决定关掉店面，踏上一次迟到的旅程。",
    director: "森田浩",
    cast: ["仲村彻", "高桥惠子", "小林凉"],
    duration: 114,
    releaseDate: "2017-09-22",
    rating: 7.5,
    views: 46000,
    updatedAt: "2023-01-19",
    featured: false,
  },
  {
    id: "guangzhou-riji",
    title: "光州日记",
    year: 2017,
    region: "韩国",
    genres: ["剧情", "家庭"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20emotional%20drama%20film%20poster%2C%20a%20woman%20holding%20an%20old%20diary%20in%20a%20sunlit%20room%20with%20lace%20curtains%2C%20warm%20dusty%20light%2C%20muted%20burgundy%20and%20beige%20palette%2C%20tender%20reflective%20mood%2C%20soft%20natural%20lighting%2C%20cinematic%20close%20composition%2C%20no%20text&width=600&height=900&seq=movie-cover-14&orientation=portrait",
    summary: "女儿翻开母亲的日记，重新读懂了那个沉默的背影。",
    synopsis:
      "母亲去世后，女儿在整理房间时发现了一本旧日记。字里行间记录的，是一个她从不知道的母亲——有着自己的梦想、委屈与爱。透过这些文字，女儿开始重新理解母亲，也重新理解了自己这些年来的疏远。",
    director: "金泰勋",
    cast: ["全美善", "廉晶雅儿", "金敏贞"],
    duration: 109,
    releaseDate: "2017-05-04",
    rating: 7.8,
    views: 49000,
    updatedAt: "2022-12-11",
    featured: false,
  },
  {
    id: "chongsheng-zhi-lan",
    title: "冲绳之蓝",
    year: 2016,
    region: "日本",
    genres: ["爱情", "文艺"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20island%20romance%20film%20poster%2C%20a%20woman%20wading%20in%20clear%20turquoise%20okinawa%20water%20at%20dusk%2C%20palm%20silhouettes%2C%20warm%20golden%20sunset%20with%20burgundy%20sky%2C%20tranquil%20bittersweet%20mood%2C%20soft%20cinematic%20lighting%2C%20elegant%20wide%20composition%2C%20no%20text&width=600&height=900&seq=movie-cover-15&orientation=portrait",
    summary: "在离岛上度过的那个夏天，让她重新学会了与自己和解。",
    synopsis:
      "失意的琴师纱希来到冲绳的离岛散心，被当地一位经营潜店的青年收留。海岛的慢节奏与清澈的海水，一点点抚平了她内心的焦躁。在那里，她遇见了不同的人，也遇见了那个一直被自己忽略的自己。",
    director: "宫本大辅",
    cast: ["苍井纱希", "山田悠真", "比嘉奈绪"],
    duration: 105,
    releaseDate: "2016-06-24",
    rating: 7.3,
    views: 42000,
    updatedAt: "2022-11-05",
    featured: false,
  },
  {
    id: "chunchuan-xueye",
    title: "春川雪夜",
    year: 2016,
    region: "韩国",
    genres: ["剧情", "爱情"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20snowy%20romance%20film%20poster%2C%20two%20figures%20standing%20close%20together%20under%20a%20street%20lamp%20in%20falling%20snow%20in%20a%20small%20town%2C%20warm%20amber%20glow%20against%20deep%20burgundy%20night%2C%20tender%20quiet%20mood%2C%20soft%20bokeh%20snowflakes%2C%20cinematic%20composition%2C%20no%20text&width=600&height=900&seq=movie-cover-16&orientation=portrait",
    summary: "一场大雪封住的小城，成了两人重新靠近的契机。",
    synopsis:
      "为了处理祖母的旧宅，秀贤回到故乡春川，却遇上了封路的大雪。她与年少时的邻家哥哥在同一个屋檐下度过几晚。往事、遗憾与未说出口的心意，在这个安静的雪夜里，被一点点重新拾起。",
    director: "郑哲民",
    cast: ["韩孝珠雅", "李准基宪", "朴恩彬"],
    duration: 111,
    releaseDate: "2016-12-09",
    rating: 7.6,
    views: 44000,
    updatedAt: "2022-10-02",
    featured: false,
  },
  {
    id: "kangcang-zhi-lian",
    title: "镰仓之恋",
    year: 2015,
    region: "日本",
    genres: ["爱情", "家庭"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20coastal%20town%20romance%20film%20poster%2C%20a%20woman%20on%20a%20train%20platform%20in%20kamakura%20with%20the%20sea%20in%20the%20background%2C%20late%20afternoon%20light%2C%20warm%20amber%20and%20burgundy%20tones%2C%20nostalgic%20gentle%20mood%2C%20soft%20cinematic%20lighting%2C%20elegant%20composition%2C%20no%20text&width=600&height=900&seq=movie-cover-17&orientation=portrait",
    summary: "三个姐妹在一座海边小城，共同安放彼此的过去与未来。",
    synopsis:
      "父亲去世后，三姐妹重新聚在镰仓的老屋里生活。各自带着不同的烦恼与秘密的她们，在同一个屋檐下重新磨合。海边的四季轮转之间，她们慢慢学会了原谅、告别与继续向前。",
    director: "是枝和幸",
    cast: ["绫濑千春", "长泽美月", "广濑夏帆"],
    duration: 108,
    releaseDate: "2015-08-28",
    rating: 7.9,
    views: 47000,
    updatedAt: "2022-09-14",
    featured: false,
  },
  {
    id: "jiangling-yuye",
    title: "江陵雨夜",
    year: 2015,
    region: "韩国",
    genres: ["剧情", "文艺"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20rainy%20night%20drama%20film%20poster%2C%20a%20cafe%20window%20with%20rain%20trails%20and%20warm%20interior%20light%20in%20a%20small%20gangneung%20town%2C%20reflective%20solitary%20atmosphere%2C%20deep%20burgundy%20and%20muted%20gray%20tones%2C%20soft%20cinematic%20lighting%2C%20no%20text&width=600&height=900&seq=movie-cover-18&orientation=portrait",
    summary: "失眠的作家来到海边小城，在一场场夜雨里写出了自己。",
    synopsis:
      "长期失眠的作家道允来到江陵，租下一间能听见海浪的房间，想完成搁置已久的小说。夜里他常去街角的小酒馆，与店主和几位常客闲聊。在雨声与酒意之间，他终于写下了那个他一直回避的故事。",
    director: "李尚洙",
    cast: ["苏轼道允", "金珉廷", "崔载雄"],
    duration: 100,
    releaseDate: "2015-11-06",
    rating: 7.2,
    views: 38000,
    updatedAt: "2022-08-21",
    featured: false,
  },
  {
    id: "yinzuo-zhi-deng",
    title: "银座之灯",
    year: 2014,
    region: "日本",
    genres: ["剧情", "家庭"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20urban%20drama%20film%20poster%2C%20a%20neon%20lit%20ginza%20street%20at%20night%20with%20a%20woman%20in%20a%20coat%20looking%20up%2C%20warm%20amber%20shop%20lights%20and%20deep%20burgundy%20shadows%2C%20elegant%20moody%20atmosphere%2C%20cinematic%20urban%20composition%2C%20soft%20film%20grain%2C%20no%20text&width=600&height=900&seq=movie-cover-19&orientation=portrait",
    summary: "一个老兵经营的小酒馆，装下了银座半条街的悲欢。",
    synopsis:
      "银座一间不起眼的小酒馆，是老板一郎守了三十年的地方。形形色色的客人在夜里推门而入，带来各自的故事。随着街区改造的消息传来，一郎不得不考虑关店，也重新审视自己这些年的坚持究竟为了什么。",
    director: "山崎英夫",
    cast: ["西田敏夫", "竹内结子希", "中井和彦"],
    duration: 113,
    releaseDate: "2014-10-10",
    rating: 7.4,
    views: 36000,
    updatedAt: "2022-07-18",
    featured: false,
  },
  {
    id: "mupu-huanghun",
    title: "木浦黄昏",
    year: 2014,
    region: "韩国",
    genres: ["剧情", "悬疑"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20dusk%20seaside%20drama%20film%20poster%2C%20a%20harbor%20town%20silhouette%20against%20a%20deep%20burgundy%20and%20gold%20sunset%20sky%2C%20calm%20water%20with%20moored%20boats%2C%20melancholy%20atmospheric%20mood%2C%20wide%20cinematic%20composition%2C%20moody%20lighting%2C%20no%20text&width=600&height=900&seq=movie-cover-20&orientation=portrait",
    summary: "一名刑警回到故乡小城，追查的却是自己不愿面对的旧事。",
    synopsis:
      "刑警东贤被调回故乡木浦，接手一桩看似普通的案件。随着调查推进，他发现线索指向自己年少时的一段往事，以及那群早已各奔东西的朋友。在海港的黄昏里，他必须决定，是揭开真相，还是继续沉默。",
    director: "柳成莞",
    cast: ["薛景元", "赵敏秀", "金高银雅"],
    duration: 117,
    releaseDate: "2014-05-29",
    rating: 7.5,
    views: 39000,
    updatedAt: "2022-06-09",
    featured: false,
  },
];

export const regions = ["日本", "韩国"] as const;

export const allGenres = [
  "剧情",
  "爱情",
  "悬疑",
  "惊悚",
  "家庭",
  "文艺",
] as const;

export const years = Array.from({ length: 26 }, (_, i) => 2025 - i);